/**
 * @generated SignedSource<<36f42bfe7aa69479183103005216c075>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleLiveTagArticle$data = {
  readonly flattenTypeIds: ReadonlyArray<string | null | undefined> | null | undefined;
  readonly tmpLiveArticle: {
    readonly status: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "articleLiveTagArticle";
};
export type articleLiveTagArticle$key = {
  readonly " $data"?: articleLiveTagArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleLiveTagArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleLiveTagArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flattenTypeIds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LiveArticle",
      "kind": "LinkedField",
      "name": "tmpLiveArticle",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "ce31b916140b3f044300c8ba784a08f2";

export default node;
